




































import { computed, defineComponent } from '@vue/composition-api';
import { useTaxesServices, statusBadges } from './taxes-services.hook';
import ServicesTable from './components/ServicesTable.vue';
import { TaxServicesPageInformation } from '../utils/useCustomerPageInformation.hooks';
import { MIGRATION } from '@ligo/dashboard/customer/store';
import ServiceTypeCard from './components/ServicesTypesCard.vue';

const CUSTOM_TYPES_KEY = 'custom_types';

interface CustomTypesCard {
  title: string;
  subtitle: string;
  cta_label: string;
  cta_link: string;
  slug: string;
}

export default defineComponent({
  name: 'TaxServicesHandler',
  components: { ServicesTable, ServiceTypeCard },
  setup() {
    const { t, get, load } = TaxServicesPageInformation;
    load();

    const {
      services,
      loadingServices,
      types,
      loadingTypes,
      tablePagination,
      search
    } = useTaxesServices();

    const customTypes = computed(() =>
      get<CustomTypesCard[]>(CUSTOM_TYPES_KEY, [])
    );

    const goToBookkeeping = () => {
      window.open(MIGRATION.BOOKKEEPING, '_blank');
    };

    return {
      services,
      loadingServices,
      types,
      loadingTypes,
      tablePagination,
      statusBadges,
      customTypes,
      t,
      search,
      goToBookkeeping
    };
  }
});
